module.exports = __webpack_public_path__ + "static/lframe-compare-loans-b0c1019e4e8b9c8ef54c8ded90e22c3d.png";